import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../../services/forms/form-cocina.service'

@Component({
  selector: 'app-dialog-platos',
  templateUrl: './dialog-platos.component.html',
  styleUrls: ['./dialog-platos.component.scss']
})
export class DialogPlatosComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()

  dishForm
  constructor (
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly formService: FormCocinaService,
    private readonly alimentosService: AyBService,
    public dialogRef: MatDialogRef<DialogPlatosComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.dishForm = this.fb.group({
      dish: this.formService.getDishForm()
    })
  }

  ngOnInit (): void {
    this.dishForm.get(['dish', 'nombre'])?.setValue(this.dialogData.nombre)
    this.dishForm
      .get(['dish', 'categoria'])
      ?.setValue(this.dialogData.categoria)
    this.dishForm
      .get(['dish', 'observaciones'])
      ?.setValue(this.dialogData.observaciones)
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  createPlato () {
    if (this.dishForm.get(['dish', 'nombre'])?.value) {
      const newDish = {
        nombrePlato: this.dishForm.value.dish?.nombre,
        categoria: this.dishForm.value.dish?.categoria,
        observaciones: this.dishForm.value.dish?.observaciones
      }
      console.log({
        newDish
      })
      this.alimentosService
        .mutationCreatePlato({
          newDish: {
            categoria: newDish?.categoria || '',
            nombrePlato: newDish?.nombrePlato || '',
            observaciones: newDish?.observaciones || ''
          }
        })
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe({
          next: newDishResponse => {
            console.log({
              newDishResponse
            })
            this.navigateToDetallePlato(newDishResponse.createPlato?.id ?? '')
            this.dialogRef.close(1)
          },
          error: error => {
            console.error('Error creating plato:', error)
            Swal.fire({
              title:
                'Error al crear el plato. Intente nuevamente antes de contactar al administrador.',
              toast: true,
              position: 'top-end',
              icon: 'error',
              showConfirmButton: false,
              timer: 3000
            })
          }
        })
    } else {
      Swal.fire({
        toast: true,
        position: 'top-end',
        title: 'Falta ingresar campos requeridos',
        icon: 'warning',
        showConfirmButton: false,
        timer: 3000
      })
    }
  }

  updateDish () {
    const plato = {
      nombrePlato: this.dishForm.value.dish?.nombre,
      categoria: this.dishForm.value.dish?.categoria,
      observaciones: this.dishForm.value.dish?.observaciones
    }
    console.log({
      data: this.dialogData,
      plato
    })
    this.alimentosService
      .mutationUpdatePlato({ platoId: this.dialogData?.id || '', plato })
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(({ updatePlato }) => {
        console.log({ updatePlato })
        this.dialogRef.close(1)
      })
  }

  navigateToDetallePlato (platoId: string) {
    this.router
      .navigate([`/detalle-plato/${platoId}`])
      .then(() => console.log('Navigated to Detalle Plato'))
  }
}
